"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeatureAnnouncementServiceApi = exports.GetFeatureAnnouncementResponseApiDomain = void 0;
const http_method_1 = require("../../service/http-method");
const service_api_1 = require("../../service/service-api");
// =============================================================================
// Response
// =============================================================================
class GetFeatureAnnouncementResponseApiDomain extends service_api_1.ServiceResponseBodyApiDomain {
    constructor(props) {
        super();
        Object.assign(this, props);
    }
}
exports.GetFeatureAnnouncementResponseApiDomain = GetFeatureAnnouncementResponseApiDomain;
// =============================================================================
// API
// =============================================================================
class GetFeatureAnnouncementsServiceApi extends service_api_1.ServiceApi {
    constructor() {
        super(...arguments);
        this.method = http_method_1.HttpMethod.GET;
        this.internalPath = "/myinfo/feature-announcements/api/v1/user";
        this.path = "/myinfo/feature-announcements/api/v1/user";
    }
}
exports.getFeatureAnnouncementServiceApi = new GetFeatureAnnouncementsServiceApi();
exports.getFeatureAnnouncementServiceApi.assertValidations();
//# sourceMappingURL=get-feature-announcements-api-domain.js.map